import {EmbedContext} from 'components/EmbedContext'
import {MessageProps} from '../../components/Messages/types'
import {NinchatInfoMessageTypes} from 'api/types/messages'
import {useAppSelector} from 'hooks'
import {useContext} from 'react'

const USER_INFO_MESSAGE_TYPES: string[] = [
    NinchatInfoMessageTypes.NinchatInfoJoinMessage,
    NinchatInfoMessageTypes.NinchatInfoMemberMessage,
    NinchatInfoMessageTypes.NinchatInfoPartMessage,
    NinchatInfoMessageTypes.NinchatInfoUserMessage,
]

export const useHideAgentInfoMessage = (message: MessageProps): boolean => {
    const embed = useContext(EmbedContext)
    const userId = useAppSelector(({ninchat}) => ninchat.user_id)
    const isEmbedQueueChannel = embed?.variant === 'queue' || embed?.variant === 'channel'

    return (
        isEmbedQueueChannel &&
        !!embed?.agentName &&
        USER_INFO_MESSAGE_TYPES.includes(message.message_type) &&
        (!!message.user_name || !!message.user_name_old) &&
        !message.user_deleted &&
        message.user_id !== userId
    )
}
